import React from "react";
import {
  ChartLineUpIcon,
  TargetIcon,
  TrendUpIcon,
  TrophyIcon,
} from "@phosphor-icons/react";
import styles from "../AthleteExerciseHistoryPage.module.scss";

interface StatsGridProps {
  currentPR?: { value: number; unit: string; date: string };
  trainingsCount: number;
  testResultsCount: number;
  profilesCount: number;
}

function formatDate(d?: string): string {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  } catch {
    return d;
  }
}

const StatsGrid: React.FC<StatsGridProps> = ({
  currentPR,
  trainingsCount,
  testResultsCount,
  profilesCount,
}) => {
  return (
    <div className={styles.statsGrid}>
      <div className={styles.statCard}>
        <div className={styles.statIconRow}>
          <TrophyIcon size={18} weight="bold" color="#ffd15a" />
          <p className={styles.statLabel}>PR corrente</p>
        </div>
        <p className={styles.statValue}>
          {currentPR ? `${currentPR.value} ${currentPR.unit}` : "—"}
        </p>
        <p className={styles.statSub}>
          {currentPR ? formatDate(currentPR.date) : "Nessun test"}
        </p>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statIconRow}>
          <ChartLineUpIcon size={18} weight="bold" color="#063444" />
          <p className={styles.statLabel}>Allenamenti</p>
        </div>
        <p className={styles.statValue}>{trainingsCount}</p>
        <p className={styles.statSub}>Sessioni log</p>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statIconRow}>
          <TargetIcon size={18} weight="bold" color="#063444" />
          <p className={styles.statLabel}>Test eseguiti</p>
        </div>
        <p className={styles.statValue}>{testResultsCount}</p>
        <p className={styles.statSub}>testResults</p>
      </div>

      <div className={styles.statCard}>
        <div className={styles.statIconRow}>
          <TrendUpIcon size={18} weight="bold" color="#063444" />
          <p className={styles.statLabel}>Profili</p>
        </div>
        <p className={styles.statValue}>{profilesCount}</p>
        <p className={styles.statSub}>Profiling Hub</p>
      </div>
    </div>
  );
};

export default StatsGrid;
